import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface GradientBackgroundProps {
  children: React.ReactNode;
  variant?: 'background' | 'chat';
  sx?: SxProps<Theme>;
}

export const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  variant = 'background',
  sx,
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        background: variant === 'chat' ? 'linear-gradient(to right, #FAFAFA, #F4F2FF)' : 'linear-gradient(to right, #F8F8FB, #E9E5FF)',
        backgroundAttachment: 'fixed',
        transition: 'transform 0.2s, box-shadow 0.2s',
        ...sx,
      }}
    >
      {variant === 'background' && (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `radial-gradient(
            circle at 2px 2px,
            rgba(0, 0, 0, 0.1) 1.7px,
            transparent 0
          )`,
          backgroundSize: '32px 32px',
          backgroundAttachment: 'fixed',
        }}
      />
      )}
      <Box sx={{ position: 'relative', display: 'flex', width: '100%', height: '100%' }}>
        {children}
      </Box>
    </Box>
  );
};

export default GradientBackground;
